<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lKATIb/images/cover.jpg?1705026943048" alt="This image is the cover for the book Blood, Guts and Gore"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blood, Guts and Gore
      </h1>
      <p class="bookDescription body article font2">
        <p>John Gordon Smith wrote one of the most vivid, honest and readable personal accounts of the Battle of Waterloo and the ensuing campaign, where he served as a surgeon in the12th Light Dragoons, but his classic narrative was only published in a limited edition in the 1830s and since then it has been virtually unknown. His warts-and-all depiction of the British army in Belgium and France and the fighting at Waterloo rivals many of the more famous and often reprinted military memoirs of the period. That is why Gareth Glover, one of the foremost experts on the battle and the archive sources relating to it, has sought to republish the narrative now, with a full introduction and explanatory notes.  Smith’s account reads like a novel, in a chatty, easy-going style, but it often records deeply shocking scenes and behaviour so scandalous that he had to avoid naming names. As well as recalling, in graphic detail, his experience as a medic during the battle, he records the aftermath, the allied occupation of France. His writing, which describes the truly dreadful consequences of the fighting as only a surgeon would see them, also gives the reader a rare insight into his role and a memorable impression of the life in the army as a whole.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gareth Glover
      </h2>
      
      <p class="authorDescription body article">John Gordon Smith qualified as a doctor in Edinburgh in 1810 and began his army medical career as a hospital mate on 25 April 1811. He became an assistant surgeon to the 11th Light Dragoons in March 1813 and transferred to the 12th Light Dragoons in October of the same year serving in the Peninsular War. In 1815, with the 12th Light Dragoons, he served in Belgium during the Waterloo campaign and the occupation of France that followed. In 1818 he was placed on half pay and he never returned to military service. He published the two volume The English Army at Waterloo and in France in 1830 and died in London in September 1833.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40b53c0f